import React, {CSSProperties} from "react";
import { ActionProps } from "./interface";
import ActionsButton from "./styles";


function Action({active, isDelete = false, cursor, style, children, ...props}: ActionProps) {
	return (
		<ActionsButton
			{...props}
			isDelete={isDelete}
			style={
			  {
			  	...style,
			  	cursor,
			  	"--fill": active?.fill,
			  	"--background": active?.background
			  } as CSSProperties
			}
		>
			{children}
		</ActionsButton>
	);
}


export default Action;
